import React, { useState, useEffect } from "react";
import { Button } from "./Button";
import "../App.css";
import "./Navbar.css";
import { Link } from "react-router-dom";
import web from "./images/lacuna.png";
// import web2 from './images/login2.png'
import { MdAccountCircle } from "react-icons/md";
import PersonIcon from "@mui/icons-material/Person";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAuthentication from "../services/authentication/AuthenticationService";
import TokenService from "../services/jwt-token/jwt-token";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoginStatus from "../redux/actions";
import profile from "../assets/img/profile/profile.png";

export const Navbar = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const loginState = useSelector((state) => state.loginReducer.login);
	console.log(loginState, "loginstatus");
	const [click, setClick] = useState(false);
	const [button, setButton] = useState(true);

	const { isAuthenticated } = useAuthentication();

	console.log(isAuthenticated, "authejhsdlfhdsfhlsf");

	const handleClick = () => {
		setClick(!click);
	};
	// const closeMobileMenu = () => {
		// setClick(false);
	// };
	const showButton = () => {
		if (window.innerWidth <= 950) {
			setButton(false);
		} else {
			setButton(true);
		}
	};
	useEffect(() => {
		showButton();
	}, []);

	window.addEventListener("resize", showButton);

	let loginStatus = false;
	let logout_visible;

	if (loginStatus) {
		loginStatus = "Profile";
	} else {
		loginStatus = "Login";
		logout_visible = "none";
	}

	const notify = () => {
		toast.info("Login Now", {
			position: "top-center",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		});
	};

	function refreshPage() {
		// let url = window.location.href='/' 
	}	

	function closeMobileMenu(){
		const navBar = document.querySelectorAll(".nav-link");
		const navCollapse = document.querySelector(".navbar-collapse.collapse");
		navBar.forEach(function (a){
			a.addEventListener("click", function(){
				navCollapse.classList.remove("show");
			})
		})

		let navBar2 = document.querySelectorAll('.dropdown-item ');
		let navCollapse2 = document.querySelector('.navbar-collapse.collapse');
		navBar2.forEach(function (a) {
		  a.addEventListener('click', function () {
			navCollapse2.classList.remove('show')
			
		  })
		});
	}
	
	return (
		<>
			<header className="header-wrapper">
				<nav className="navbar navbar-expand-lg fixed-top">
					<div className="container-fluid">
						<Link className="navbar-brand navbar-logo" to="/" >
							<img src={web} alt="" className="img-fluid" onClick={refreshPage}/>
						</Link>
						<button
							className="navbar-toggler"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#navbarNav"
							aria-controls="navbarNavAltMarkup"
							aria-expanded="false"
							aria-label="Toggle navigation"
						>
							<div className="menu-icon" onClick={handleClick}>
								<i
									className={
										click
											? "fa-solid fa-xmark navbar-toggler-icon"
											: "fa-solid fa-bars navbar-toggler-icon"
									}
								/>
							</div>
						</button>
						<div
							className="collapse navbar-collapse justify-content-end"
							id="navbarNav"
						>
							<ul className="navbar-nav menu-navbar-nav">
								{/* <li className="nav-item">
                  <Link to="/about" className='nav-link' onClick={closeMobileMenu}>About</Link>
                </li> */}
								<li className="nav-item">
									<Link
										to="/workshop"
										className="nav-link"
										onClick={closeMobileMenu}
									>
										Workshop
									</Link>
								</li>
								<li className="nav-item">
									<Link
										to="/contest"
										className="nav-link"
										onClick={closeMobileMenu}
									>
										Contest
									</Link>
								</li>
								{/* <li className="nav-item">
                  <Link to="/program" className='nav-link' onClick={closeMobileMenu}>Program</Link>
                </li>
                <li className="nav-item">
                  <Link to="/gallery" className='nav-link' onClick={closeMobileMenu}>Gallery</Link>
                </li> */}
								<li className="nav-item">
									<Link
										to="/blog"
										className="nav-link"
										onClick={closeMobileMenu}
									>
										Blogs
									</Link>
								</li>

								<li className="nav-item">
									<Link
										to="/event"
										className="nav-link"
										onClick={closeMobileMenu}
									>
										Events
									</Link>
								</li>

								<li className="nav-item dropdown">
									<Link
										className="nav-link dropdown-toggle"
										to="#"
										id="navbarDropdown"
										role="button"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										Opportunity
									</Link>
									<ul
										className="dropdown-menu"
										aria-labelledby="navbarDropdown"
									>
										<li>
											<Link
												className="dropdown-item"
												to="/design-thinking"
												onClick={closeMobileMenu}
											>
												Design Thinking
											</Link>
										</li>
										<li>
											<Link
												className="dropdown-item"
												to="/mentor"
												onClick={closeMobileMenu}
											>
												Mentorship
											</Link>
										</li>
										<li>
											<Link
												className="dropdown-item"
												to="/career"
												onClick={closeMobileMenu}
											>
												Career
											</Link>
										</li>
									</ul>
								</li>
								<li className="nav-item dropdown">
									<Link
										className="nav-link dropdown-toggle"
										to="#"
										id="navbarDropdown"
										role="button"
										data-bs-toggle="dropdown"
										aria-expanded="false"
										onClick={closeMobileMenu}
									>
										More
									</Link>
									<ul
										className="dropdown-menu"
										aria-labelledby="navbarDropdown"
										onClick={closeMobileMenu}
									>
										<li>
											<Link
												className="dropdown-item"
												to="/about"
												onClick={closeMobileMenu}
											>
												About
											</Link>
										</li>
										<li>
											<Link
												className="dropdown-item"
												to="/program"
												onClick={closeMobileMenu}
											>
												Program
											</Link>
										</li>
									</ul>
								</li>

								{/* <li className="nav-item">
                  <Link to="/membership" className='nav-link-mobile' onClick={closeMobileMenu}> Membership</Link>
                </li> */}
								<li className="nav-item">
									<Link
										to="/membership"
										className="nav-link-mobile"
										onClick={closeMobileMenu}
									>
										{" "}
										Membership
									</Link>
								</li>

								{/* <li className="nav-item"> */}
								{/* <Link to="/login" className='' onClick={closeMobileMenu}> */}
								{/* <i className="fa-solid fa-user-plus fa-2x ms-2 ia"></i> */}
								{/* <MdAccountCircle size="3em" color='white'/> */}
								{/* </Link> */}
								{/* </li> */}

								{/* dorpdown Login */}
								<li className="nav-item dropdown">
									<Link
										className="nav-link dropdown-toggle login-item-link"
										to="#"
										id="navbarDropdown"
										role="button"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										<div id="hide-dropdown-arrow"></div>
										{isAuthenticated && loginState ? (
											<img src={profile} height="35px" />
										) : (
											<PersonIcon />
										)}
									</Link>

									<ul
										className="dropdown-menu dropdown-menu-end"
										aria-labelledby="navbarDropdown"
									>
										{isAuthenticated && loginState ? (
											<>
												<li>
													<Link
														className="dropdown-item"
														to="appMember/profile"
													>
														Profile
													</Link>
												</li>
												<li>
													<span
														className="dropdown-item"
														role="button"
														onClick={() => {
															TokenService.clearToken();
															dispatch(
																LoginStatus(
																	false
																)
															);
															navigate("/", {state : {messageType: "success", message: "Logout Successful"}});
														}}
													>
														Logout
													</span>
												</li>
											</>
										) : (
											<li>
												<Link
													className="dropdown-item"
													to="/login"
												>
													{loginStatus}
												</Link>
											</li>
										)}
									</ul>
								</li>
							</ul>
							{/* { button && <Button  buttonStyle='btn-secondary'>Sign up</Button>} */}
						</div>
					</div>
				</nav>
			</header>
		</>
	);
};
export default Navbar;